import React from "react";
import { InvoiceLogo } from "../../../../components/logos";
import { PaymentDueDetails } from "../../../../components/modals/paymentDueDetails";

export const ActionButton = ({ id ,membership}) => {

  const [modalFlag, setModalFlag] = React.useState(false);

  const handleModalToggle = (e) => {
    setModalFlag((prevState) => !prevState);
  };
  return (
    <div className="c-pointer">
      {modalFlag && <PaymentDueDetails showModal={modalFlag} toggle={handleModalToggle} payload={{id ,membership}}/>}
      <InvoiceLogo color={"var(--primary)"} onClickFunction={handleModalToggle} />
    </div>
  );
};
